import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/ic_folder.png';

const _withScopeId = n => (_pushScopeId("data-v-c9e4d0c8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "search-files-select-warp"
};
const _hoisted_2 = {
  class: "tags-main"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_4 = [_hoisted_3];
import { reactive, ref } from 'vue';
import { getTextWidth } from '@/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'searchFilesSelect',
  props: {
    filePath: {
      type: String,
      default: ''
    },
    // 打开文件列表前是否需要校验
    beforeShowDialogValid: {
      type: Boolean,
      default: false
    },
    showBatchSwitch: {
      type: Boolean,
      default: true
    },
    canSelectFolder: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    uploadConfig: {
      type: Object,
      default: {}
    }
  },
  emits: ['update:filePath', 'on-confirm', 'show-dialog', 'load-node'],

  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const fileInput = ref();
    const treeProps = {
      label: 'name',
      children: 'zones',
      isLeaf: 'leaf'
    };
    expose({
      fileInput
    });
    const isBatch = ref(false);
    const treeFilesRef = ref();
    const dialogConfig = reactive({
      visible: false,
      loading: false,
      config: {
        title: '文件列表',
        destroyOnClose: true // isShowConfirm: false

      },
      confirm: done => {
        console.log(nodeItem.value);

        if (nodeItem.value) {
          emit('update:filePath', splitFilePath(nodeItem.value, nodeItem.value.data.name));
          dialogConfig.visible = false;
          done();
          emit('on-confirm', nodeItem.value);
        } else {
          emit('update:filePath', '/');
          dialogConfig.visible = false;
          done();
          emit('on-confirm', nodeItem.value);
        }
      }
    }); // const filePath = ref('');

    const splitFilePath = (node, str) => {
      if (node.parent.parent && node.parent.level > 1) {
        str = node.parent.data.name + str;
        return splitFilePath(node.parent, str);
      } else {
        return str;
      }
    };

    const treeFileList = ref([{
      name: 'vod/souths'
    }]);

    const loadNode = (node, resolve) => {
      console.log(123, node);
      emit('load-node', node, resolve);
      return;
    };

    const nodeTarget = ref();
    const nodeItem = ref();

    const nodeClick = (node, data, $event) => {
      console.log(node, data, $event); // console.log(treeFileList.value);
      // console.log(treeFilesRef.value);

      if (node.data.disabled) return;

      if (isBatch.value || props.canSelectFolder) {
        if (nodeTarget.value) {
          if (nodeTarget.value.style.backgroundImage && nodeItem.value.data.id == node.data.id) {
            nodeTarget.value.style.backgroundImage = '';
            nodeTarget.value = null;
            nodeItem.value = null;
          } else {
            nodeTarget.value.style.backgroundImage = '';
            nodeTarget.value = $event.target;
            nodeItem.value = node;
            $event.target.style.backgroundImage = 'linear-gradient(to right, #d2e9ff, #a6cff5)';
          }
        } else {
          nodeItem.value = node;
          nodeTarget.value = $event.target;
          $event.target.style.backgroundImage = 'linear-gradient(to right, #d2e9ff, #a6cff5)';
        }
      } else {
        if (node.data.type == 'dir') {
          return;
        } else {
          if (nodeTarget.value) {
            if (nodeTarget.value.style.backgroundImage && nodeItem.value.data.id == node.data.id) {
              nodeTarget.value.style.backgroundImage = '';
              nodeTarget.value = null;
              nodeItem.value = null;
            } else {
              nodeTarget.value.style.backgroundImage = '';
              nodeTarget.value = $event.target;
              nodeItem.value = node;
              $event.target.style.backgroundImage = 'linear-gradient(to right, #d2e9ff, #a6cff5)';
            }
          } else {
            nodeItem.value = node;
            nodeTarget.value = $event.target;
            $event.target.style.backgroundImage = 'linear-gradient(to right, #d2e9ff, #a6cff5)';
          }
        }
      }

      console.log('nodeItem', nodeItem.value);
    }; // 批量处理switch滑块change事件


    const switchChange = val => {
      console.log(val);

      if (!val) {
        if (nodeItem.value && nodeItem.value.data.type == 'dir') {
          nodeTarget.value.style.backgroundImage = '';
          nodeTarget.value = null;
          nodeItem.value = null;
        }
      }
    };

    const showDialog = () => {
      if (props.beforeShowDialogValid) {
        emit('show-dialog', () => {
          dialogConfig.visible = true;
        });
      } else {
        dialogConfig.visible = true;
      }
    }; // 触发文件上传输入框


    const triggerFileInput = () => {
      if (props.disabled) return false; //禁用

      fileInput.value.click();
    }; // 处理文件选择


    const handleFileChange = event => {
      const file = event.target.files;

      if (file) {
        console.log("已选择文件:", file); // 先emit，再重置 input 的值以允许上传相同文件

        emit('on-confirm', file); //event.target.value = null; 
      }
    }; //  内容超出时显示提示


    const tipDisabled = ref(false);

    const showTextTip = e => {
      const target = e.target;
      const width = getTextWidth(target.innerText, {
        fontSize: '14px'
      });
      tipDisabled.value = target.offsetWidth < width;
    };

    watch(() => dialogConfig.visible, val => {
      if (val) {
        isBatch.value = false;
        nodeTarget.value = null;
        nodeItem.value = null;
      }
    });
    return (_ctx, _cache) => {
      const _component_MPopper = _resolveComponent("MPopper");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_MPopper, {
        disabled: tipDisabled.value,
        placement: "top",
        trigger: "hover",
        content: __props.filePath
      }, {
        reference: _withCtx(() => [_createElementVNode("span", {
          onMouseover: showTextTip,
          class: "pointer file-name"
        }, _toDisplayString(__props.filePath), 33)]),
        _: 1
      }, 8, ["disabled", "content"]), _createElementVNode("div", {
        class: _normalizeClass(['ic-folder-warp', 'pointer', __props.disabled ? 'not_allow' : '']),
        onClick: triggerFileInput
      }, _hoisted_4, 2), _createElementVNode("input", _mergeProps({
        type: "file",
        ref_key: "fileInput",
        ref: fileInput
      }, __props.uploadConfig, {
        onChange: handleFileChange,
        style: {
          "display": "none"
        }
      }), null, 16)])]);
    };
  }

});